let wordList = [];

wordList[ 1 ] = [
	'A',
	'B',
	'C',
	'D',
	'E',
	'F',
	'G',
	'H',
	'I',
	'J',
	'K',
	'L',
	'M',
	'N',
	'O',
	'P',
	'Q',
	'R',
	'S',
	'T',
	'U',
	'V',
	'W',
	'X',
	'Y',
	'Z',
];
wordList[ 3 ] = [
	"AAH",
	"ABS",
	"ACE",
	"ACK",
	"ACT",
	"ADD",
	"ADS",
	"AGE",
	"AHA",
	"AHH",
	"AID",
	"AIL",
	"AIM",
	"AIR",
	"ALL",
	"AMP",
	"AND",
	"ANT",
	"ANY",
	"APE",
	"APT",
	"ARC",
	"ARE",
	"ARK",
	"ARM",
	"ART",
	"ASH",
	"ASK",
	"ASP",
	"ATE",
	"AWE",
	"AXE",
	"AYE",
	"BAD",
	"BAG",
	"BAH",
	"BAM",
	"BAN",
	"BAR",
	"BAT",
	"BAY",
	"BBQ",
	"BED",
	"BEE",
	"BEG",
	"BET",
	"BIB",
	"BID",
	"BIG",
	"BIN",
	"BIO",
	"BIT",
	"BIZ",
	"BOB",
	"BOD",
	"BOO",
	"BOP",
	"BOT",
	"BOW",
	"BOX",
	"BOY",
	"BUD",
	"BUG",
	"BUN",
	"BUS",
	"BUT",
	"BUY",
	"BYE",
	"CAB",
	"CAD",
	"CAM",
	"CAN",
	"CAP",
	"CAR",
	"CAT",
	"COB",
	"COD",
	"COG",
	"COM",
	"CON",
	"COP",
	"COT",
	"COW",
	"COY",
	"CRY",
	"CUB",
	"CUD",
	"CUE",
	"CUP",
	"CUT",
	"DAB",
	"DAD",
	"DAY",
	"DEN",
	"DEW",
	"DIB",
	"DID",
	"DIE",
	"DIG",
	"DIM",
	"DIN",
	"DIP",
	"DOE",
	"DOG",
	"DOH",
	"DOT",
	"DRY",
	"DUB",
	"DUD",
	"DUE",
	"DUG",
	"DUO",
	"DYE",
	"EAR",
	"EAT",
	"EBB",
	"EEK",
	"EEL",
	"EGG",
	"EGO",
	"EKE",
	"ELF",
	"ELK",
	"ELM",
	"EMU",
	"END",
	"EON",
	"ERA",
	"ERE",
	"ERR",
	"EVE",
	"EWE",
	"EWW",
	"EYE",
	"FAB",
	"FAD",
	"FAN",
	"FAR",
	"FAX",
	"FED",
	"FEE",
	"FEW",
	"FIB",
	"FIG",
	"FIN",
	"FIR",
	"FIT",
	"FIX",
	"FLU",
	"FLY",
	"FOG",
	"FOR",
	"FOX",
	"FRO",
	"FRY",
	"FUN",
	"FUR",
	"GAB",
	"GAP",
	"GAS",
	"GEL",
	"GEM",
	"GET",
	"GIG",
	"GIN",
	"GOB",
	"GOD",
	"GOT",
	"GUM",
	"GUN",
	"GUT",
	"GUY",
	"GYM",
	"HAD",
	"HAM",
	"HAS",
	"HAT",
	"HAY",
	"HEE",
	"HEH",
	"HEN",
	"HER",
	"HES",
	"HEW",
	"HEX",
	"HEY",
	"HID",
	"HIM",
	"HIP",
	"HIS",
	"HIT",
	"HMM",
	"HOG",
	"HOP",
	"HOT",
	"HOW",
	"HUB",
	"HUE",
	"HUG",
	"HUM",
	"HUN",
	"HUT",
	"ICE",
	"ICK",
	"ICY",
	"IDE",
	"ILK",
	"ILL",
	"IMP",
	"INK",
	"INN",
	"INS",
	"ION",
	"IRE",
	"IRK",
	"ITS",
	"IVY",
	"JAB",
	"JAG",
	"JAM",
	"JAR",
	"JAW",
	"JAY",
	"JET",
	"JIB",
	"JIG",
	"JOB",
	"JOE",
	"JOG",
	"JOT",
	"JOY",
	"JUG",
	"JUT",
	"KEG",
	"KEY",
	"KID",
	"KIN",
	"KIT",
	"KOI",
	"LAB",
	"LAD",
	"LAG",
	"LAM",
	"LAP",
	"LAW",
	"LAX",
	"LAY",
	"LED",
	"LEG",
	"LET",
	"LID",
	"LIE",
	"LIL",
	"LIP",
	"LIT",
	"LOB",
	"LOG",
	"LOL",
	"LOP",
	"LOT",
	"LOW",
	"LUG",
	"LUX",
	"LYE",
	"MAD",
	"MAG",
	"MAN",
	"MAP",
	"MAR",
	"MAT",
	"MAX",
	"MAY",
	"MED",
	"MEH",
	"MET",
	"MIC",
	"MID",
	"MIN",
	"MIT",
	"MIX",
	"MOB",
	"MOD",
	"MOM",
	"MOO",
	"MOP",
	"MOW",
	"MUD",
	"MUG",
	"MUM",
	"NAB",
	"NAG",
	"NAH",
	"NAP",
	"NAW",
	"NAY",
	"NET",
	"NEW",
	"NIL",
	"NIT",
	"NOD",
	"NOT",
	"NOW",
	"NUN",
	"NUT",
	"OAF",
	"OAK",
	"OAR",
	"OAT",
	"ODD",
	"ODE",
	"OFF",
	"OFT",
	"OIL",
	"OLD",
	"OLE",
	"ONE",
	"OOF",
	"OPT",
	"ORB",
	"ORC",
	"ORE",
	"OUR",
	"OUT",
	"OWL",
	"OWN",
	"PAD",
	"PAL",
	"PAN",
	"PAR",
	"PAT",
	"PAW",
	"PAY",
	"PEA",
	"PEG",
	"PEN",
	"PEP",
	"PER",
	"PET",
	"PEW",
	"PIC",
	"PIE",
	"PIG",
	"PIN",
	"PIP",
	"PIT",
	"PLY",
	"POD",
	"POP",
	"POT",
	"POW",
	"PRO",
	"PRY",
	"PUG",
	"PUN",
	"PUP",
	"PUT",
	"QUO",
	"RAD",
	"RAG",
	"RAM",
	"RAN",
	"RAP",
	"RAT",
	"RAW",
	"RAY",
	"RED",
	"REP",
	"RIB",
	"RID",
	"RIG",
	"RIM",
	"RIP",
	"ROB",
	"ROD",
	"ROT",
	"ROW",
	"RUB",
	"RUE",
	"RUG",
	"RUM",
	"RUN",
	"RUT",
	"RYE",
	"SAD",
	"SAG",
	"SAP",
	"SAT",
	"SAW",
	"SAX",
	"SAY",
	"SEA",
	"SEE",
	"SET",
	"SEW",
	"SHE",
	"SHH",
	"SHY",
	"SIM",
	"SIN",
	"SIP",
	"SIR",
	"SIT",
	"SIX",
	"SKA",
	"SKI",
	"SKY",
	"SLY",
	"SOB",
	"SON",
	"SOW",
	"SOY",
	"SPA",
	"SPY",
	"SUB",
	"SUE",
	"SUM",
	"SUN",
	"TAB",
	"TAD",
	"TAG",
	"TAN",
	"TAP",
	"TAR",
	"TAT",
	"TAX",
	"TEA",
	"TEE",
	"TEN",
	"THE",
	"TIE",
	"TIL",
	"TIN",
	"TIP",
	"TIS",
	"TOE",
	"TON",
	"TOO",
	"TOP",
	"TOT",
	"TOW",
	"TOY",
	"TRY",
	"TUB",
	"TUG",
	"TUX",
	"TWO",
	"UFO",
	"USE",
	"VAN",
	"VAT",
	"VEG",
	"VET",
	"VIA",
	"VID",
	"VIE",
	"VIP",
	"VOW",
	"WAG",
	"WAR",
	"WAS",
	"WAX",
	"WAY",
	"WED",
	"WET",
	"WHO",
	"WHY",
	"WIG",
	"WIN",
	"WIT",
	"WOE",
	"WON",
	"WOW",
	"WRY",
	"YAH",
	"YAK",
	"YAM",
	"YAP",
	"YAY",
	"YEP",
	"YES",
	"YET",
	"YOU",
	"YUK",
	"YUM",
	"YUP",
	"ZAG",
	"ZAP",
	"ZEN",
	"ZIG",
	"ZIP",
	"ZOO"
];
wordList[ 4 ] = [
	"ABLE",
	"ABLY",
	"ABUT",
	"ACED",
	"ACES",
	"ACHE",
	"ACHY",
	"ACID",
	"ACME",
	"ACNE",
	"ACRE",
	"ACTS",
	"ADDS",
	"AFAR",
	"AFRO",
	"AGED",
	"AGES",
	"AGOG",
	"AHEM",
	"AHOY",
	"AIDE",
	"AILS",
	"AIMS",
	"AINT",
	"AIRS",
	"AIRY",
	"AJAR",
	"AKIN",
	"ALAS",
	"ALLY",
	"ALMS",
	"ALOE",
	"ALSO",
	"ALTO",
	"AMMO",
	"AMOK",
	"AMPS",
	"ANEW",
	"ANTS",
	"APES",
	"APEX",
	"AQUA",
	"ARCH",
	"AREA",
	"ARID",
	"ARMS",
	"ARMY",
	"ARTS",
	"ARTY",
	"ASAP",
	"ASHY",
	"ASKS",
	"ATOM",
	"ATOP",
	"AUNT",
	"AURA",
	"AUTO",
	"AVID",
	"AVOW",
	"AWAY",
	"AXES",
	"AXIS",
	"BABE",
	"BABY",
	"BACH",
	"BACK",
	"BAGS",
	"BAIL",
	"BAIN",
	"BAIT",
	"BAKE",
	"BALD",
	"BALE",
	"BALK",
	"BALL",
	"BALM",
	"BAND",
	"BANE",
	"BANG",
	"BANK",
	"BARE",
	"BARK",
	"BARN",
	"BARS",
	"BASE",
	"BASH",
	"BASK",
	"BASS",
	"BATH",
	"BATS",
	"BAYS",
	"BEAD",
	"BEAK",
	"BEAM",
	"BEAN",
	"BEAR",
	"BEAT",
	"BEAU",
	"BECK",
	"BEDS",
	"BEEF",
	"BEEP",
	"BEER",
	"BEES",
	"BEET",
	"BEGS",
	"BELL",
	"BELT",
	"BEND",
	"BENT",
	"BEST",
	"BETA",
	"BETS",
	"BEVY",
	"BIAS",
	"BIDE",
	"BIDS",
	"BIKE",
	"BILE",
	"BILL",
	"BIND",
	"BING",
	"BINS",
	"BIRD",
	"BITE",
	"BITS",
	"BLAB",
	"BLAH",
	"BLED",
	"BLEW",
	"BLIP",
	"BLOB",
	"BLOT",
	"BLOW",
	"BLUE",
	"BLUR",
	"BOAR",
	"BOAT",
	"BODY",
	"BOGS",
	"BOIL",
	"BOLD",
	"BOLT",
	"BOMB",
	"BOND",
	"BONE",
	"BONK",
	"BONY",
	"BOOK",
	"BOOM",
	"BOON",
	"BOOP",
	"BOOT",
	"BORE",
	"BORN",
	"BOSS",
	"BOTH",
	"BOTS",
	"BOUT",
	"BOWL",
	"BOWS",
	"BOYS",
	"BRAD",
	"BRAG",
	"BRAN",
	"BRAS",
	"BRAT",
	"BRAY",
	"BRED",
	"BREW",
	"BRIE",
	"BRIG",
	"BRIM",
	"BROW",
	"BUCK",
	"BUDS",
	"BUFF",
	"BUGS",
	"BULB",
	"BULK",
	"BULL",
	"BUMP",
	"BUNK",
	"BUNT",
	"BUOY",
	"BURG",
	"BURL",
	"BURN",
	"BURP",
	"BURY",
	"BUSH",
	"BUSK",
	"BUST",
	"BUSY",
	"BUTS",
	"BUYS",
	"BUZZ",
	"BYES",
	"BYTE",
	"CABS",
	"CAFE",
	"CAGE",
	"CAKE",
	"CALF",
	"CALL",
	"CALM",
	"CAME",
	"CAMP",
	"CANE",
	"CANT",
	"CAPE",
	"CAPS",
	"CARB",
	"CARD",
	"CARE",
	"CARP",
	"CARS",
	"CART",
	"CASE",
	"CASH",
	"CASK",
	"CAST",
	"CATS",
	"CAVE",
	"CELL",
	"CENT",
	"CHAP",
	"CHAR",
	"CHAT",
	"CHEF",
	"CHEW",
	"CHIC",
	"CHIN",
	"CHIP",
	"CHOP",
	"CHOW",
	"CHUG",
	"CITY",
	"CLAD",
	"CLAN",
	"CLAP",
	"CLAW",
	"CLAY",
	"CLEF",
	"CLIP",
	"CLOG",
	"CLOP",
	"CLOT",
	"CLUB",
	"CLUE",
	"COAL",
	"COAT",
	"COAX",
	"CODE",
	"COIL",
	"COIN",
	"COKE",
	"COLA",
	"COLD",
	"COLT",
	"COMA",
	"COMB",
	"COME",
	"COMP",
	"COMS",
	"CONE",
	"CONK",
	"CONS",
	"COOK",
	"COOL",
	"COOP",
	"COOT",
	"COPE",
	"COPS",
	"COPY",
	"CORD",
	"CORE",
	"CORK",
	"CORN",
	"COST",
	"COTS",
	"COVE",
	"COWL",
	"COWS",
	"COZY",
	"CRAB",
	"CRAG",
	"CRAM",
	"CRED",
	"CREW",
	"CRIB",
	"CROP",
	"CROW",
	"CRUD",
	"CRUX",
	"CRYO",
	"CUBE",
	"CUBS",
	"CUFF",
	"CULL",
	"CULT",
	"CUPS",
	"CURB",
	"CURD",
	"CURE",
	"CURL",
	"CURT",
	"CUSP",
	"CUSS",
	"CUTE",
	"CUTS",
	"CYST",
	"CZAR",
	"DADS",
	"DAFT",
	"DAIS",
	"DALE",
	"DAME",
	"DAMN",
	"DAMP",
	"DANG",
	"DANK",
	"DARE",
	"DARK",
	"DARN",
	"DART",
	"DASH",
	"DATA",
	"DATE",
	"DAWN",
	"DAYS",
	"DAZE",
	"DEAD",
	"DEAF",
	"DEAL",
	"DEAN",
	"DEAR",
	"DEBT",
	"DECK",
	"DEED",
	"DEEP",
	"DEER",
	"DEFT",
	"DEFY",
	"DEJA",
	"DELI",
	"DELL",
	"DELT",
	"DEMO",
	"DENS",
	"DENT",
	"DENY",
	"DEPT",
	"DERP",
	"DESK",
	"DEUX",
	"DIAL",
	"DIBS",
	"DICE",
	"DIED",
	"DIES",
	"DIET",
	"DIGS",
	"DIKE",
	"DILL",
	"DIME",
	"DINE",
	"DING",
	"DINK",
	"DINO",
	"DINT",
	"DIPS",
	"DIRE",
	"DIRT",
	"DISC",
	"DISH",
	"DISK",
	"DIVA",
	"DIVE",
	"DOCK",
	"DODO",
	"DOES",
	"DOFF",
	"DOGS",
	"DOJO",
	"DOLE",
	"DOLL",
	"DOLT",
	"DOME",
	"DONE",
	"DONT",
	"DOOM",
	"DOOR",
	"DOPE",
	"DORM",
	"DOSE",
	"DOTE",
	"DOTS",
	"DOUR",
	"DOVE",
	"DOWN",
	"DOZE",
	"DRAB",
	"DRAG",
	"DRAT",
	"DRAW",
	"DREW",
	"DRIP",
	"DROP",
	"DRUG",
	"DRUM",
	"DUAL",
	"DUCK",
	"DUCT",
	"DUDE",
	"DUDS",
	"DUEL",
	"DUES",
	"DUET",
	"DUFF",
	"DUKE",
	"DULL",
	"DULY",
	"DUMB",
	"DUMP",
	"DUNE",
	"DUNG",
	"DUNK",
	"DUPE",
	"DUSK",
	"DUST",
	"DUTY",
	"DYAD",
	"DYED",
	"EACH",
	"EARL",
	"EARN",
	"EARS",
	"EASE",
	"EAST",
	"EASY",
	"EATS",
	"ECHO",
	"EDDY",
	"EDGE",
	"EDGY",
	"EDIT",
	"EELS",
	"EGAD",
	"EGGS",
	"EGOS",
	"ELKS",
	"ELMS",
	"ELSE",
	"EMIT",
	"ENDS",
	"ENVY",
	"EONS",
	"EPIC",
	"ERGO",
	"ETCH",
	"EVEN",
	"EVER",
	"EVES",
	"EVIL",
	"EXAM",
	"EXEC",
	"EXES",
	"EXIT",
	"EXPO",
	"EYED",
	"EYES",
	"FACE",
	"FACT",
	"FADE",
	"FADS",
	"FAIL",
	"FAIR",
	"FAKE",
	"FALL",
	"FAME",
	"FANG",
	"FANS",
	"FARE",
	"FARM",
	"FAST",
	"FATE",
	"FAUX",
	"FAVE",
	"FAWN",
	"FAZE",
	"FEAR",
	"FEAT",
	"FEED",
	"FEEL",
	"FEES",
	"FEET",
	"FELL",
	"FELT",
	"FEND",
	"FERN",
	"FEST",
	"FEUD",
	"FIAT",
	"FIGS",
	"FILE",
	"FILL",
	"FILM",
	"FIND",
	"FINE",
	"FINK",
	"FINS",
	"FIRE",
	"FIRM",
	"FIRS",
	"FISH",
	"FIST",
	"FITS",
	"FIVE",
	"FIZZ",
	"FLAG",
	"FLAK",
	"FLAN",
	"FLAP",
	"FLAT",
	"FLAW",
	"FLAX",
	"FLAY",
	"FLEA",
	"FLED",
	"FLEE",
	"FLEW",
	"FLEX",
	"FLIP",
	"FLIT",
	"FLOG",
	"FLOP",
	"FLOW",
	"FLUE",
	"FLUX",
	"FOAL",
	"FOAM",
	"FOES",
	"FOIL",
	"FOLD",
	"FOLK",
	"FOND",
	"FONT",
	"FOOD",
	"FOOL",
	"FOOT",
	"FORD",
	"FORE",
	"FORK",
	"FORM",
	"FORT",
	"FOUL",
	"FOUR",
	"FOWL",
	"FOXY",
	"FRAG",
	"FRAT",
	"FRAY",
	"FREE",
	"FRET",
	"FROG",
	"FROM",
	"FUEL",
	"FULL",
	"FUME",
	"FUND",
	"FUNK",
	"FURL",
	"FURS",
	"FURY",
	"FUSS",
	"FUZZ",
	"GAFF",
	"GAGA",
	"GAGS",
	"GAIN",
	"GAIT",
	"GALA",
	"GALE",
	"GALL",
	"GALS",
	"GAME",
	"GAMY",
	"GANG",
	"GAPE",
	"GAPS",
	"GARB",
	"GASP",
	"GATE",
	"GAVE",
	"GAWK",
	"GAZE",
	"GEAR",
	"GEEK",
	"GELS",
	"GELT",
	"GEMS",
	"GENE",
	"GENT",
	"GERM",
	"GETS",
	"GIFT",
	"GIGS",
	"GILD",
	"GILL",
	"GILT",
	"GIMP",
	"GINS",
	"GIRD",
	"GIRL",
	"GIST",
	"GIVE",
	"GLAD",
	"GLAM",
	"GLEE",
	"GLEN",
	"GLIB",
	"GLOP",
	"GLOW",
	"GLUE",
	"GLUM",
	"GLUT",
	"GNAT",
	"GNAW",
	"GOAD",
	"GOAL",
	"GOAT",
	"GOBS",
	"GODS",
	"GOER",
	"GOES",
	"GOLD",
	"GOLF",
	"GONE",
	"GONG",
	"GOOD",
	"GOOF",
	"GOSH",
	"GOTH",
	"GOUT",
	"GOWN",
	"GRAB",
	"GRAD",
	"GRAM",
	"GRAY",
	"GREW",
	"GREY",
	"GRID",
	"GRIM",
	"GRIN",
	"GRIP",
	"GRIT",
	"GROG",
	"GROW",
	"GRUB",
	"GUFF",
	"GULF",
	"GULL",
	"GULP",
	"GUMS",
	"GUNK",
	"GUNS",
	"GURU",
	"GUSH",
	"GUST",
	"GUTS",
	"GUYS",
	"GYMS",
	"GYRO",
	"HACK",
	"HAHA",
	"HAIL",
	"HAIR",
	"HALF",
	"HALL",
	"HALO",
	"HALT",
	"HAMS",
	"HAND",
	"HANG",
	"HARD",
	"HARE",
	"HARK",
	"HARM",
	"HARP",
	"HART",
	"HASH",
	"HATE",
	"HATH",
	"HATS",
	"HAUL",
	"HAVE",
	"HAWK",
	"HAZE",
	"HAZY",
	"HEAD",
	"HEAL",
	"HEAP",
	"HEAR",
	"HEAT",
	"HECK",
	"HEED",
	"HEEL",
	"HEFT",
	"HEIR",
	"HELD",
	"HELL",
	"HELM",
	"HELP",
	"HEMP",
	"HENS",
	"HERB",
	"HERD",
	"HERE",
	"HERO",
	"HERS",
	"HICK",
	"HIDE",
	"HIGH",
	"HIKE",
	"HILL",
	"HILT",
	"HIMS",
	"HIND",
	"HINT",
	"HIPS",
	"HIRE",
	"HISS",
	"HITS",
	"HIVE",
	"HOAX",
	"HOBO",
	"HOCK",
	"HOES",
	"HOGS",
	"HOLD",
	"HOLE",
	"HOLY",
	"HOME",
	"HONE",
	"HONK",
	"HOOD",
	"HOOF",
	"HOOK",
	"HOOP",
	"HOOT",
	"HOPE",
	"HOPS",
	"HORN",
	"HOSE",
	"HOST",
	"HOTS",
	"HOUR",
	"HOWL",
	"HOWS",
	"HUFF",
	"HUGE",
	"HUGS",
	"HULA",
	"HULK",
	"HULL",
	"HUMM",
	"HUMP",
	"HUMS",
	"HUNG",
	"HUNK",
	"HUNT",
	"HURL",
	"HURT",
	"HUSH",
	"HUSK",
	"HUTS",
	"HYMN",
	"HYPE",
	"ICED",
	"ICKY",
	"ICON",
	"IDEA",
	"IDLE",
	"IDLY",
	"IDOL",
	"IFFY",
	"ILLS",
	"INCH",
	"INFO",
	"INNS",
	"INTO",
	"IONS",
	"IOTA",
	"IRIS",
	"IRON",
	"ISLE",
	"ITCH",
	"ITEM",
	"ITSY",
	"JABS",
	"JACK",
	"JADE",
	"JAGS",
	"JAIL",
	"JAMS",
	"JAPE",
	"JARS",
	"JAWS",
	"JAZZ",
	"JEDI",
	"JEEP",
	"JEER",
	"JEEZ",
	"JEST",
	"JETS",
	"JIBE",
	"JIGS",
	"JINX",
	"JIVE",
	"JOBS",
	"JOEY",
	"JOGS",
	"JOHN",
	"JOIN",
	"JOKE",
	"JOLT",
	"JOWL",
	"JOYS",
	"JUDO",
	"JULY",
	"JUMP",
	"JUNE",
	"JUNK",
	"JURY",
	"JUST",
	"JUTS",
	"KALE",
	"KEEL",
	"KEEN",
	"KEEP",
	"KEGS",
	"KELP",
	"KEPT",
	"KERN",
	"KEYS",
	"KICK",
	"KIDS",
	"KILL",
	"KILN",
	"KILT",
	"KIND",
	"KING",
	"KISS",
	"KITE",
	"KITS",
	"KIWI",
	"KNEE",
	"KNEW",
	"KNIT",
	"KNOT",
	"KNOW",
	"KOOK",
	"LABS",
	"LACE",
	"LACK",
	"LACY",
	"LADS",
	"LADY",
	"LAID",
	"LAIN",
	"LAIR",
	"LAKE",
	"LAMB",
	"LAME",
	"LAMP",
	"LAND",
	"LANE",
	"LANK",
	"LAPS",
	"LARD",
	"LARK",
	"LASH",
	"LASS",
	"LAST",
	"LATE",
	"LAVA",
	"LAWN",
	"LAWS",
	"LAYS",
	"LAZE",
	"LAZY",
	"LEAD",
	"LEAF",
	"LEAK",
	"LEAN",
	"LEAP",
	"LEEK",
	"LEER",
	"LEFT",
	"LEGO",
	"LEGS",
	"LEND",
	"LENS",
	"LENT",
	"LESS",
	"LEST",
	"LETS",
	"LEVY",
	"LIAR",
	"LICE",
	"LICK",
	"LIDS",
	"LIED",
	"LIER",
	"LIES",
	"LIEU",
	"LIFE",
	"LIFT",
	"LIKE",
	"LILT",
	"LILY",
	"LIMB",
	"LIME",
	"LIMO",
	"LIMP",
	"LINE",
	"LINK",
	"LINT",
	"LION",
	"LIPS",
	"LISP",
	"LIST",
	"LITE",
	"LIVE",
	"LOAD",
	"LOAF",
	"LOAM",
	"LOAN",
	"LOBE",
	"LOCH",
	"LOCK",
	"LOCO",
	"LODE",
	"LOFT",
	"LOGO",
	"LOGS",
	"LOIN",
	"LONE",
	"LONG",
	"LOOK",
	"LOOM",
	"LOON",
	"LOOP",
	"LOOT",
	"LOPE",
	"LORD",
	"LORE",
	"LOSE",
	"LOSS",
	"LOST",
	"LOTS",
	"LOUD",
	"LOUT",
	"LOVE",
	"LOWS",
	"LUCK",
	"LUGE",
	"LULL",
	"LUMP",
	"LUNG",
	"LURE",
	"LURK",
	"LUSH",
	"LUST",
	"LUTE",
	"LUXE",
	"LYNX",
	"LYRE",
	"MACE",
	"MACH",
	"MADE",
	"MAGE",
	"MAGI",
	"MAGS",
	"MAID",
	"MAIL",
	"MAIM",
	"MAIN",
	"MAKE",
	"MALE",
	"MALL",
	"MALT",
	"MAME",
	"MANE",
	"MANY",
	"MAPS",
	"MARE",
	"MARK",
	"MARS",
	"MART",
	"MASH",
	"MASK",
	"MASS",
	"MAST",
	"MATE",
	"MATH",
	"MATS",
	"MAUL",
	"MAYO",
	"MAZE",
	"MEAD",
	"MEAL",
	"MEAN",
	"MEAT",
	"MEDS",
	"MEEK",
	"MEGA",
	"MELT",
	"MEME",
	"MEMO",
	"MEND",
	"MENS",
	"MENU",
	"MEOW",
	"MERE",
	"MESA",
	"MESH",
	"MESS",
	"META",
	"METH",
	"MICE",
	"MILD",
	"MILE",
	"MILK",
	"MILL",
	"MIME",
	"MIND",
	"MINE",
	"MINI",
	"MINK",
	"MINT",
	"MIRE",
	"MISS",
	"MIST",
	"MITE",
	"MITT",
	"MOAN",
	"MOAT",
	"MOBS",
	"MOCK",
	"MODE",
	"MOJO",
	"MOLD",
	"MOLE",
	"MOLT",
	"MOMS",
	"MONK",
	"MONO",
	"MOOD",
	"MOON",
	"MOOR",
	"MOOT",
	"MOPE",
	"MOPS",
	"MORE",
	"MOSH",
	"MOSS",
	"MOST",
	"MOTH",
	"MOVE",
	"MOWN",
	"MUCH",
	"MUCK",
	"MUFF",
	"MUGS",
	"MULE",
	"MULL",
	"MUSE",
	"MUSH",
	"MUSK",
	"MUST",
	"MUTE",
	"MUTT",
	"MYTH",
	"NAAN",
	"NADA",
	"NAGS",
	"NAIL",
	"NAME",
	"NANO",
	"NAPE",
	"NAPS",
	"NARC",
	"NARY",
	"NAVY",
	"NEAR",
	"NEAT",
	"NECK",
	"NEED",
	"NEON",
	"NERD",
	"NEST",
	"NETS",
	"NEWS",
	"NEWT",
	"NEXT",
	"NICE",
	"NICK",
	"NIGH",
	"NINE",
	"NITE",
	"NITS",
	"NODE",
	"NODS",
	"NOES",
	"NOIR",
	"NONE",
	"NOOK",
	"NOON",
	"NOPE",
	"NORM",
	"NOSE",
	"NOSH",
	"NOSY",
	"NOTE",
	"NOUN",
	"NUDE",
	"NUKE",
	"NULL",
	"NUMB",
	"NUNS",
	"NUTS",
	"OAKS",
	"OARS",
	"OATH",
	"OATS",
	"OBEY",
	"OBOE",
	"ODDS",
	"ODOR",
	"OGRE",
	"OILS",
	"OILY",
	"OINK",
	"OKAY",
	"OKRA",
	"OMEN",
	"OMIT",
	"ONCE",
	"ONES",
	"ONLY",
	"ONTO",
	"ONUS",
	"ONYX",
	"OOPS",
	"OOZE",
	"OPAL",
	"OPEN",
	"OPUS",
	"ORAL",
	"ORCA",
	"ORES",
	"OUCH",
	"OURS",
	"OUST",
	"OUTS",
	"OVAL",
	"OVEN",
	"OVER",
	"OWED",
	"OWES",
	"OWLS",
	"OWNS",
	"OXEN",
	"PACE",
	"PACK",
	"PACT",
	"PADS",
	"PAGE",
	"PAID",
	"PAIL",
	"PAIN",
	"PAIR",
	"PALE",
	"PALL",
	"PALM",
	"PALS",
	"PANE",
	"PANG",
	"PANS",
	"PANT",
	"PAPA",
	"PARE",
	"PARK",
	"PART",
	"PASS",
	"PAST",
	"PATE",
	"PATH",
	"PATS",
	"PAVE",
	"PAWN",
	"PAWS",
	"PAYS",
	"PEAK",
	"PEAL",
	"PEAR",
	"PEAS",
	"PEAT",
	"PECK",
	"PEEK",
	"PEEL",
	"PEEP",
	"PEER",
	"PEGS",
	"PELT",
	"PEND",
	"PENS",
	"PENT",
	"PERK",
	"PERM",
	"PERP",
	"PEST",
	"PETS",
	"PHEW",
	"PICK",
	"PIED",
	"PIER",
	"PIES",
	"PIGS",
	"PIKE",
	"PILE",
	"PILL",
	"PINE",
	"PING",
	"PINK",
	"PINS",
	"PINT",
	"PIPE",
	"PIPS",
	"PITH",
	"PITS",
	"PITY",
	"PLAN",
	"PLAY",
	"PLEA",
	"PLED",
	"PLOD",
	"PLOP",
	"PLOT",
	"PLOW",
	"PLOY",
	"PLUG",
	"PLUM",
	"PLUS",
	"POCK",
	"PODS",
	"POEM",
	"POET",
	"POKE",
	"POLE",
	"POLL",
	"POLO",
	"POLY",
	"POMP",
	"POND",
	"PONG",
	"PONY",
	"POOL",
	"POOP",
	"POOR",
	"POPE",
	"POPS",
	"PORE",
	"PORK",
	"PORT",
	"POSE",
	"POSH",
	"POST",
	"POSY",
	"POTS",
	"POUR",
	"POUT",
	"PRAY",
	"PREP",
	"PREY",
	"PRIM",
	"PROD",
	"PROM",
	"PROP",
	"PROS",
	"PUCE",
	"PUCK",
	"PUFF",
	"PULL",
	"PULP",
	"PUMA",
	"PUMP",
	"PUNK",
	"PUNS",
	"PUNT",
	"PUNY",
	"PURE",
	"PURL",
	"PURR",
	"PUSH",
	"PUSS",
	"PUTS",
	"PUTT",
	"PYRE",
	"PYRO",
	"QUAD",
	"QUAY",
	"QUIP",
	"QUIT",
	"QUIZ",
	"RACE",
	"RACK",
	"RACY",
	"RAFF",
	"RAFT",
	"RAGE",
	"RAGS",
	"RAID",
	"RAIL",
	"RAIN",
	"RAKE",
	"RAMP",
	"RAMS",
	"RANG",
	"RANK",
	"RANT",
	"RAPS",
	"RAPT",
	"RARE",
	"RASH",
	"RASP",
	"RATE",
	"RATS",
	"RAVE",
	"RAYS",
	"RAZE",
	"READ",
	"REAL",
	"REAM",
	"REAP",
	"REAR",
	"RECK",
	"REDO",
	"REDS",
	"REED",
	"REEF",
	"REEK",
	"REEL",
	"REIN",
	"RELY",
	"REND",
	"RENT",
	"REPS",
	"REST",
	"RIBS",
	"RICE",
	"RICH",
	"RICK",
	"RIDE",
	"RIFE",
	"RIFF",
	"RIFT",
	"RIGS",
	"RILE",
	"RIMS",
	"RIND",
	"RING",
	"RINK",
	"RIOT",
	"RIPE",
	"RIPS",
	"RISE",
	"RISK",
	"RITZ",
	"RIVE",
	"ROAD",
	"ROAM",
	"ROAN",
	"ROAR",
	"ROBE",
	"ROBS",
	"ROCK",
	"RODE",
	"RODS",
	"ROIL",
	"ROLE",
	"ROLF",
	"ROLL",
	"ROOF",
	"ROOK",
	"ROOM",
	"ROOT",
	"ROPE",
	"ROSE",
	"ROSY",
	"ROTS",
	"ROUT",
	"ROVE",
	"ROWS",
	"RUBS",
	"RUBY",
	"RUDE",
	"RUFF",
	"RUGS",
	"RUIN",
	"RULE",
	"RUMP",
	"RUNE",
	"RUNG",
	"RUNS",
	"RUSE",
	"RUSH",
	"RUST",
	"RUTS",
	"SACK",
	"SAFE",
	"SAGA",
	"SAGE",
	"SAID",
	"SAIL",
	"SAKE",
	"SALE",
	"SALT",
	"SAME",
	"SAND",
	"SANE",
	"SANG",
	"SANK",
	"SANS",
	"SAPS",
	"SASH",
	"SAVE",
	"SAWS",
	"SAYS",
	"SCAB",
	"SCAM",
	"SCAN",
	"SCAR",
	"SEAL",
	"SEAM",
	"SEAR",
	"SEAS",
	"SEAT",
	"SECT",
	"SEED",
	"SEEK",
	"SEEM",
	"SEEN",
	"SEEP",
	"SEER",
	"SEES",
	"SELF",
	"SELL",
	"SEMI",
	"SEND",
	"SENT",
	"SERF",
	"SETS",
	"SEWN",
	"SHAM",
	"SHED",
	"SHIM",
	"SHIN",
	"SHIP",
	"SHOE",
	"SHOO",
	"SHOP",
	"SHOT",
	"SHOW",
	"SHUN",
	"SHUT",
	"SICK",
	"SIDE",
	"SIFT",
	"SIGH",
	"SIGN",
	"SILK",
	"SILL",
	"SILO",
	"SILT",
	"SING",
	"SINK",
	"SINS",
	"SIPS",
	"SIRE",
	"SIRS",
	"SITE",
	"SITS",
	"SIZE",
	"SKEW",
	"SKID",
	"SKIM",
	"SKIN",
	"SKIP",
	"SKIS",
	"SKIT",
	"SLAB",
	"SLAM",
	"SLAP",
	"SLAT",
	"SLAY",
	"SLED",
	"SLEW",
	"SLID",
	"SLIM",
	"SLIP",
	"SLIT",
	"SLOB",
	"SLOG",
	"SLOP",
	"SLOT",
	"SLOW",
	"SLUG",
	"SLUM",
	"SLUR",
	"SMOG",
	"SMUG",
	"SNAG",
	"SNAP",
	"SNIP",
	"SNOB",
	"SNOT",
	"SNOW",
	"SNUB",
	"SNUG",
	"SOAK",
	"SOAP",
	"SOAR",
	"SOBS",
	"SOCK",
	"SODA",
	"SOFA",
	"SOFT",
	"SOIL",
	"SOLD",
	"SOLE",
	"SOLO",
	"SOME",
	"SONG",
	"SONS",
	"SOON",
	"SOOT",
	"SORE",
	"SORT",
	"SOUL",
	"SOUP",
	"SOUR",
	"SPAM",
	"SPAN",
	"SPAR",
	"SPAS",
	"SPAT",
	"SPAY",
	"SPEC",
	"SPED",
	"SPEW",
	"SPIN",
	"SPIT",
	"SPOT",
	"SPRY",
	"SPUD",
	"SPUN",
	"SPUR",
	"STAB",
	"STAG",
	"STAR",
	"STAT",
	"STAY",
	"STEM",
	"STEP",
	"STEW",
	"STIR",
	"STOP",
	"STOW",
	"STUB",
	"STUD",
	"STUN",
	"STYE",
	"SUBS",
	"SUCH",
	"SUCK",
	"SUDS",
	"SUIT",
	"SULK",
	"SUMO",
	"SUMS",
	"SUNG",
	"SUNK",
	"SUNS",
	"SURE",
	"SURF",
	"SUSS",
	"SWAB",
	"SWAG",
	"SWAM",
	"SWAN",
	"SWAP",
	"SWAT",
	"SWAY",
	"SWIG",
	"SWIM",
	"SWUM",
	"SYNC",
	"TABS",
	"TACK",
	"TACO",
	"TACT",
	"TADA",
	"TAGS",
	"TAIL",
	"TAKE",
	"TALC",
	"TALE",
	"TALK",
	"TALL",
	"TAME",
	"TANG",
	"TANK",
	"TANS",
	"TAPE",
	"TAPS",
	"TARP",
	"TART",
	"TASK",
	"TAUT",
	"TAXI",
	"TEAK",
	"TEAL",
	"TEAM",
	"TEAR",
	"TEAS",
	"TEAT",
	"TECH",
	"TEEN",
	"TELL",
	"TEMP",
	"TEND",
	"TENS",
	"TENT",
	"TERM",
	"TEST",
	"TEXT",
	"THAN",
	"THAT",
	"THAW",
	"THEM",
	"THEN",
	"THEY",
	"THIN",
	"THIS",
	"THRU",
	"THUD",
	"THUG",
	"TICK",
	"TIDE",
	"TIDY",
	"TIED",
	"TIER",
	"TIES",
	"TIFF",
	"TIKI",
	"TILE",
	"TILL",
	"TILT",
	"TIME",
	"TINE",
	"TINS",
	"TINT",
	"TINY",
	"TIPS",
	"TIRE",
	"TOAD",
	"TODO",
	"TOED",
	"TOES",
	"TOFU",
	"TOGA",
	"TOIL",
	"TOLD",
	"TOLL",
	"TOMB",
	"TOME",
	"TONE",
	"TONG",
	"TONS",
	"TOOK",
	"TOOL",
	"TOON",
	"TOOT",
	"TOPS",
	"TORE",
	"TORN",
	"TORT",
	"TOSS",
	"TOTE",
	"TOTS",
	"TOUT",
	"TOWN",
	"TOYS",
	"TRAM",
	"TRAP",
	"TRAY",
	"TREE",
	"TREK",
	"TRIM",
	"TRIO",
	"TRIP",
	"TROD",
	"TROT",
	"TRUE",
	"TUBA",
	"TUBE",
	"TUBS",
	"TUCK",
	"TUFT",
	"TUNA",
	"TUNE",
	"TURF",
	"TURN",
	"TUSK",
	"TUTU",
	"TWAS",
	"TWEE",
	"TWIG",
	"TWIN",
	"TWIT",
	"TWOS",
	"TYKE",
	"TYPE",
	"TYPO",
	"UBER",
	"UFOS",
	"UGLY",
	"UNDO",
	"UNIT",
	"UNTO",
	"UPON",
	"URGE",
	"URNS",
	"USED",
	"USER",
	"USES",
	"VAIL",
	"VAIN",
	"VALE",
	"VAMP",
	"VANE",
	"VANS",
	"VARY",
	"VASE",
	"VAST",
	"VATS",
	"VEAL",
	"VEEP",
	"VEER",
	"VEIL",
	"VEIN",
	"VEND",
	"VENT",
	"VERB",
	"VERT",
	"VERY",
	"VEST",
	"VETO",
	"VETS",
	"VIAL",
	"VIBE",
	"VIEW",
	"VILE",
	"VINE",
	"VISA",
	"VOID",
	"VOLT",
	"VOTE",
	"VOWS",
	"WACK",
	"WADE",
	"WAFT",
	"WAGE",
	"WAIF",
	"WAIL",
	"WAIT",
	"WAKE",
	"WALE",
	"WALK",
	"WALL",
	"WAND",
	"WANE",
	"WANT",
	"WARD",
	"WARE",
	"WARM",
	"WARN",
	"WARP",
	"WARS",
	"WART",
	"WARY",
	"WASH",
	"WASP",
	"WATT",
	"WAVE",
	"WAVY",
	"WAXY",
	"WAYS",
	"WEAK",
	"WEAN",
	"WEAR",
	"WEBS",
	"WEDS",
	"WEED",
	"WEEK",
	"WEEP",
	"WELD",
	"WELL",
	"WELT",
	"WENT",
	"WEPT",
	"WERE",
	"WEST",
	"WETS",
	"WHAM",
	"WHAT",
	"WHEE",
	"WHEN",
	"WHEW",
	"WHEY",
	"WHIM",
	"WHIP",
	"WHIZ",
	"WHOM",
	"WHYS",
	"WICK",
	"WIDE",
	"WIFE",
	"WIGS",
	"WILD",
	"WILE",
	"WILL",
	"WILT",
	"WILY",
	"WIMP",
	"WIND",
	"WINE",
	"WING",
	"WINK",
	"WINS",
	"WIPE",
	"WIRE",
	"WIRY",
	"WISE",
	"WISH",
	"WISP",
	"WITH",
	"WITS",
	"WOAH",
	"WOES",
	"WOKE",
	"WOLF",
	"WOMB",
	"WONT",
	"WOOD",
	"WOOF",
	"WOOL",
	"WOOT",
	"WORD",
	"WORE",
	"WORK",
	"WORM",
	"WORN",
	"WOVE",
	"WRAP",
	"WREN",
	"WRIT",
	"WUSS",
	"XRAY",
	"YACK",
	"YADA",
	"YAKS",
	"YALL",
	"YAMS",
	"YANK",
	"YARD",
	"YARN",
	"YAWN",
	"YEAH",
	"YEAR",
	"YELL",
	"YELP",
	"YETI",
	"YIPE",
	"YOGA",
	"YOKE",
	"YOLK",
	"YORE",
	"YOUR",
	"YOWL",
	"YUCK",
	"YULE",
	"YURT",
	"ZANY",
	"ZEAL",
	"ZERO",
	"ZEST",
	"ZINC",
	"ZING",
	"ZION",
	"ZITS",
	"ZONE",
	"ZOOM",
	"ZOOS"
];

function focusAndOpenKeyboard( el, timeout = 100 ) {

	if ( !el ) {
		return;
	}

	console.log( 'element offset', el.offsetTop, el.offsetLeft );

	// Align temp input element approximately where the input element is
	// so the cursor doesn't jump around
	var __tempEl__ = document.createElement( 'input' );
	__tempEl__.style.position = 'absolute';
	__tempEl__.style.top = ( el.offsetTop + 7 ) + 'px';
	__tempEl__.style.left = el.offsetLeft + 'px';
	__tempEl__.style.height = 0;
	__tempEl__.style.opacity = 0;

	// Put this temp element as a child of the page <body> and focus on it
	document.body.appendChild( __tempEl__ );
	__tempEl__.focus();

	// The keyboard is open. Now do a delayed focus on the target element
	setTimeout(
		function() {
			el.focus();
			el.click();
			// Remove the temp element
			document.body.removeChild( __tempEl__ );
		},
		timeout
	);

}
/**
 * Is this a touch enabled device or not?
 *
 * @return {boolean}
 */
const is_touch_device = function() {

	return ( ( 'ontouchstart' in window ) || ( navigator.MaxTouchPoints > 0 ) || ( navigator.msMaxTouchPoints > 0 ) );

};


const game = {

	/**
	 * The game app.
	 *
	 * @type {object}
	 */
	app: null,


	/**
	 * Constants for the game modes.
	 *
	 * @type {int}
	 */
	MODE_MENU: 1,
	MODE_PLAY: 2,
	MODE_FINISH: 3,
	MODE_COUNTDOWN: 4,


	/**
	 * Length of game in seconds.
	 *
	 * @type {int}
	 */
	gameLength: 60,


	/**
	 * Levels to select from.
	 *
	 * @type {array}
	 */
	levels: [
		{ n: '1 letter', v: 1, p: false },
		{ n: '3 letters', v: 3, p: false },
		{ n: '4 letters', v: 4, p: false },
		// { n: '5 letters', v: 5, p: true },
		// { n: '6 letters', v: 6, p: true },
		// { n: '7 letters', v: 7, p: true },
	],


	input: null,


	/**
	 * Initialize the app.
	 */
	init: function() {

		if ( game.app ) {
			return;
		}

		const $comp = document.querySelector( '#game-container' );

		game.app = new Reef(
			$comp,
			{
				data: {
					currentWord: '',
					nextLetter: '',
					typed: '',
					correct: 0,
					mode: game.MODE_MENU,
					timeRemaining: 3,
					hasFocus: true,
					wordLength: 3,
				},
				template: game.template,
			}
		);

		game.app.render();

		$comp.addEventListener( 'click', game.click );
		// Radio buttons for selecting word length.
		$comp.addEventListener( 'change', game.click );

		// Keyboard input.
		game.input = document.querySelector( '#gameInput' );
		game.input.addEventListener( 'input', game.keyup );

	},


	/**
	 * Create a new game.
	 *
	 * @return {void}
	 */
	newGame: function() {

		const firstWord = game.pickWord();
		const firstLetter = firstWord[ 0 ];

		game.app.setData(
			{
				currentWord: firstWord,
				nextLetter: firstLetter,
				typed: '',
				correct: 0,
				timeRemaining: 3,
				mode: game.MODE_COUNTDOWN,
			}
		);

	},


	/**
	 * Pick a word.
	 *
	 * @param {string} currentWord The current word to check.
	 * @return {string}
	 */
	pickWord: function( currentWord = '' ) {

		const words = wordList[ game.app.data.wordLength ];
		let word = currentWord;

		// Make sure the word is not the same as the previous one.
		do {
			word = words[ Math.floor( Math.random() * words.length ) ].toLowerCase();
		} while ( word === currentWord );

		return word;

	},


	/**
	 * The template wrapper.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	template: function( props ) {

		let html = '';

		switch ( props.mode ) {
			case game.MODE_MENU:
				html += game.templateMenu( props );
				break;

			case game.MODE_PLAY:
				html += game.templateGame( props );
				break;

			case game.MODE_FINISH:
				html += game.templateFinish( props );
				break;

			case game.MODE_COUNTDOWN:
				html += game.templateCountdown( props );
				break;

		}

		return html;

	},


	/**
	 * The menu template.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateMenu: function( props ) {

		return `
			<h1 class="m-b4">Typing Ninja<span class="carat"></span></h1>
			<button class="button jumbo m-b5" data-action="play">Play</button>
			${game.templatePartWordLength( props )}
		`;

	},


	/**
	 * The game template.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateGame: function( props ) {

		let word = `<span>${props.typed}</span><span class="carat"></span><span class="o50">${props.currentWord.replace( props.typed, '' )}</span>`;

		return `
			<div class="f1 m-b5" id="theWord">${word}</div>
			<div class="f3 fg-blue-dark f-fw900">${props.timeRemaining}</div>
			${game.focusGameButton( props )}
		`;

	},


	/**
	 * Display the focus game button.
	 * This is only needed on touch devices.
	 * It allows the user to display the keyboard.
	 * This is because the keyboard is hidden by default on touch devices.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	focusGameButton: function( props ) {

		if ( !props.hasFocus ) {
			return `<button data-action="focus">Display Keyboard</button>`;
		}

		return ``;

	},


	/**
	 * Focus the keyboard.
	 *
	 * @return {void}
	 */
	focusKeyboard: function() {

		if ( game.input ) {

			game.input.focus();

			game.app.setData(
				{
					hasFocus: true
				}
			);

		}

	},


	/**
	 * The game finished template.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateFinish: function( props ) {

		// Description.
		let description = `, ${props.wordLength} Letter Words`;

		if ( 1 === parseInt( props.wordLength ) ) {
			// Needs a space after the word before.
			description = ' Letters';
		}

		// Title.
		let title = 'Oh No 😞';

		if ( props.correct > 0 ) {
			title = 'Nice Try! 👍';
		}

		if ( props.correct > 10 ) {
			title = 'Way to go! 😊';
		}

		if ( props.correct > 20 ) {
			title = '🏅 Well Done! 😃';
		}

		if ( props.correct > 30 ) {
			title = '🥉 Great Job! 😎';
		}

		if ( props.correct > 40 ) {
			title = '🥈 Amazing! 🤩';
		}

		if ( props.correct > 50 ) {
			title = '🥇 Outstanding! 🌟';
		}

		return `
			<div class="f1 m-b4 f-fw900">${title}</div>
			<div class="f2 m-b5"><strong class="fg-green-dark">${props.correct}</strong>${description}</div>
			<button class="button" data-action="again">Play Again</button>
		`;

	},


	/**
	 * The game intro countdown.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateCountdown: function( props ) {

		return `
			<div class="f1 fg-blue f-fw900">${props.timeRemaining}</div>
		`;

	},


	/**
	 * Display the word length settings.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templatePartWordLength: function( props ) {

		let html = '';

		game.levels.forEach(
			( item ) => {
				let checked = '';

				if ( props.wordLength === item.v ) {
					checked = 'checked="checked"';
				}

				html += `<input type="radio" name="wordLength" data-action="changeWordLength" label="${item.n}" value="${item.v}" ${checked} />`;
			}
		);

		return `<div class="radioGroup word-length">${html}</div>`;

	},


	/**
	 * The click events.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	click: function( e ) {

		const action = e.target.getAttribute( 'data-action' );

		// console.log( action );

		if ( !action ) {
			game.focusKeyboard();
			return;
		}

		e.preventDefault();

		// Play the game.
		if ( 'play' === action ) {

			game.newGame();
			game.focusKeyboard();

			let countdownDuration = 1000;

			setTimeout( game.updateCountdown, countdownDuration );

		}

		// Play again (and go back to the main menu).
		if ( 'again' === action ) {

			game.app.setData(
				{
					mode: game.MODE_MENU,
				}
			);

		}

		// Focus the input.
		if ( 'focus' === action ) {

			game.focusKeyboard();

		}

		// Change the word length.
		if ( 'changeWordLength' === action ) {

			game.app.setData(
				{
					wordLength: parseInt( e.target.value )
				}
			);

			setTimeout( () => { game.app.render() }, 10 );

		}

	},


	/**
	 * Update the intro countdown timer.
	 *
	 * @return {void}
	 */
	updateCountdown: function() {

		if ( game.updateTimer( game.MODE_PLAY ) ) {

			// Update the countdown.
			setTimeout( game.updateCountdown, 1000 );

		} else {

			// Countdown ended so switch to 'play' mode.
			game.app.setData(
				{
					timeRemaining: game.gameLength
				}
			);

			setTimeout( game.updateTime, 1000 );

		}

	},


	/**
	 * Update the play timer.
	 *
	 * @return {void}
	 */
	updateTime: function() {

		if ( game.updateTimer() ) {

			setTimeout( game.updateTime, 1000 );

			const $focused = document.activeElement;
			if ( 'gameInput' !== $focused.id ) {

				game.focusKeyboard();

				if ( is_touch_device() ) {

					game.app.setData(
						{
							hasFocus: false,
						}
					);

				}

			}

		}

	},


	/**
	 * Global app timer for all timed events.
	 *
	 * @param {int} next_mode The next mode to change to when the time runs out.
	 * @return {boolean} True if the timer is continuing and false if it has expired.
	 */
	updateTimer: function( next_mode = game.MODE_FINISH ) {

		const data = game.app.data;
		const time_remaining = data.timeRemaining - 1;

		// Time has run out.
		if ( time_remaining === 0 ) {

			game.app.setData(
				{
					mode: next_mode
				}
			);

			return false;

		}

		// Update the app time remaining.
		game.app.setData(
			{
				timeRemaining: time_remaining
			}
		);

		return true;

	},


	/**
	 * The keyup event.
	 *
	 * @param {event} e The keyup event.
	 * @return {void}
	 */
	keyup: function( e ) {

		// Input element id.
		const $target = e.target;
		const id = $target.id;
		const value = $target.value;

		if ( 'gameInput' !== id ) {
			return;
		}

		// Get data.
		const data = game.app.data;

		// Quit if the game isn't playing.
		if ( game.MODE_PLAY !== data.mode ) {
			return;
		}

		// Get the typed character.
		// const character = String.fromCharCode( e.keyCode ).toLowerCase();
		const character = value.charAt( value.length - 1 ).toLowerCase();

		if ( !character ) {
			return;
		}

		// Get the default values.
		let typed = data.typed;
		let currentWord = data.currentWord;
		let nextLetter = data.nextLetter;
		let correct = data.correct;

		// If the typed character is the same as the next letter.
		if ( character === nextLetter ) {
			typed = data.typed + character;
			nextLetter = currentWord.replace( typed, '' )[ 0 ];
		}

		// If the typed word is the same as the target word.
		// Select the next word and reset everything.
		if ( typed === currentWord ) {
			typed = '';
			currentWord = game.pickWord( currentWord );
			nextLetter = currentWord[ 0 ];
			correct++;

			game.explode( 'theWord' );
		}

		// Update everything.
		game.app.setData(
			{
				typed,
				currentWord,
				nextLetter,
				correct,
			}
		);

		game.input.value = '';

	},


	/**
	 * Explode confetti.
	 *
	 * @param {string} id The element to target.
	 * @return {void}
	 */
	explode: function( id ) {

		confetti(
			{
				particleCount: 60,
				spread: 360,
				ticks: 70,
				origin: { y: 0.3 },
				gravity: 0.75,
				startVelocity: 30,
				scalar: 1.75,
				disableForReducedMotion: true,
			}
		);

	},

};



; (
	function() {

		'use strict';

		ready(

			function() {

				game.init();

			}

		);

	}
)();
